var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7167 15.9999C16.0473 16.0208 20 12.4335 20 8.06948C20 3.29712 16.0473 -0.00158672 11.7167 5.72587e-07H7.98969C3.60721 -0.00158672 0 3.29811 0 8.06948C0 12.4345 3.60721 16.0209 7.98969 15.9999H11.7167Z",
    fill: "#0079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00693 0.661255C4.00234 0.662525 0.757291 3.94028 0.756348 7.98569C0.757291 12.0304 4.0023 15.3078 8.00693 15.3091C12.0125 15.3078 15.2582 12.0304 15.2587 7.98569C15.2581 3.94028 12.0125 0.662525 8.00693 0.661255ZM3.41098 7.98569C3.41476 6.00887 4.63739 4.32317 6.36145 3.6533V12.3171C4.63739 11.6476 3.41473 9.96279 3.41098 7.98569ZM9.65177 12.319V3.65302C11.3765 4.32127 12.601 6.00792 12.6041 7.98569C12.601 9.96406 11.3765 11.6494 9.65177 12.319Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7167 15.9999C16.0473 16.0208 20 12.4335 20 8.06948C20 3.29712 16.0473 -0.00158672 11.7167 5.72587e-07H7.98969C3.60721 -0.00158672 0 3.29811 0 8.06948C0 12.4345 3.60721 16.0209 7.98969 15.9999H11.7167Z",
    fill: "#0079BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05573 0.661255C4.02418 0.662525 0.757297 3.94028 0.756348 7.98569C0.757297 12.0304 4.02415 15.3078 8.05573 15.3091C12.0882 15.3078 15.3558 12.0304 15.3563 7.98569C15.3557 3.94028 12.0882 0.662525 8.05573 0.661255ZM3.42885 7.98569C3.43265 6.00887 4.66351 4.32317 6.39918 3.6533V12.3171C4.66351 11.6476 3.43262 9.96279 3.42885 7.98569ZM9.71165 12.319V3.65302C11.448 4.32127 12.6807 6.00792 12.6839 7.98569C12.6807 9.96406 11.448 11.6494 9.71165 12.319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/DinersClub.be9bc266cffa664ceac01c679f667c63.svg";
export { ForwardRef as ReactComponent };